import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.treasureHuntCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.treasureHuntCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.treasureHuntCollections.data.treasureHuntCollections,
  (collections = []) => collections
);
const getGroupData = createSelector(
  (state) => state.treasureHuntCollections.data.treasureHuntGroupData,
  (groupData = {}) => groupData
);
const getPageCount = createSelector(
  (state) => state.treasureHuntCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupData,
  getHasLoaded,
  getPageCount,
};
